module.exports = __webpack_public_path__ + "img/stop_btn.f78ce49a.png";